import { render, staticRenderFns } from "./VisualizzaFilePdf.vue?vue&type=template&id=46f45fdb&"
import script from "./VisualizzaFilePdf.vue?vue&type=script&lang=js&"
export * from "./VisualizzaFilePdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports